import { RootState } from '..'
import _find from 'lodash/find'
import { ExportData } from './ExportData'

export const getExportByCombinationId = (state: RootState, combinationId: string) => {
  return _find(state.exportDownload.entries, entry => entry.combinationId === combinationId) as ExportData
}
